import { render, staticRenderFns } from "./dynamicFormBuilder.vue?vue&type=template&id=36c56501"
import script from "./dynamicFormBuilder.vue?vue&type=script&lang=js"
export * from "./dynamicFormBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports